import React, { Component } from "react";

export default class footer extends Component {
  render() {
    return (
      <>
        <div class="footer out-footer">
          <div class="copyright">
            <p>
              Copyright © by
              <a href="https://bajipro.net" target="_blank">
                bajipro.net
              </a>
              2026
            </p>
          </div>
        </div>
      </>
    );
  }
}
